import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    currentPage:1
}
const orderListReducer = createSlice({
    name:'orderListReducer',
    initialState,
    reducers:{
        setCurrentPage(state,action) { // 修改页数
            state.currentPage = action.payload
        }
    }
})

export const { setCurrentPage } = orderListReducer.actions

export default orderListReducer.reducer